// Lifecycle stage labels & order for the admin dashboard
export const LIFECYCLE_STAGES = [
  { id: "application_received", label: "Application received", order: 0 },
  { id: "in_review", label: "In review", order: 1 },
  { id: "decision", label: "Decision", order: 2 },
  { id: "onboarding", label: "Onboarding", order: 3 },
];

export const STAGE_BY_ID = Object.fromEntries(
  LIFECYCLE_STAGES.map((s) => [s.id, s])
);
